import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SecondaryToolbarComponent } from './secondary-toolbar.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { IconModule } from '@visurel/iconify-angular';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { BreadcrumbsModule } from '../breadcrumbs/breadcrumbs.module';
import { TranslateService } from '@ngx-translate/core';
import { CreateTranslateModule } from 'src/app/Translation';


@NgModule({
  declarations: [SecondaryToolbarComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    IconModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    BreadcrumbsModule,
    // CreateTranslateModule(),
  ],
  exports: [SecondaryToolbarComponent]
})

export class SecondaryToolbarModule {
  constructor(){
    
  }
  // constructor(
  //   public translate: TranslateService) { 
  //     const browserLang = localStorage.getItem('lang');  
  //     translate.use(browserLang); 
  //   }
}
